import { useState } from "react";
import { FormattedMessage as FM } from "react-intl";

import Spinner from "componentsv2/widgets/Spinner";
import { buttonColors, buttonOutlineColors } from "theme/theme";
import { cn } from "tools/ui";

const base =
  "flex hover:shadow-md bg-gradient-to-r py-1 px-3 items-center text-center cursor-pointer hover:opacity-90  disabled:!cursor-not-allowed justify-center gap-2 rounded-xl active:scale-95 active:shadow-md px-3";

function Button({
  name,
  size,
  style,
  height,
  color,
  disabled,
  onClick,
  content,
  alingTextRight,
  children,
  iconLeft,
  iconRight,
  outline,
  icon,
  loading,
  noFill,
  title = "",
}) {
  const [inactive, setInactive] = useState(disabled?.value || false);
  const [isLoading, setLoading] = useState(false);

  async function handleClick(e) {
    e.preventDefault();
    if (isLoading || inactive) return;
    setInactive(true);
    setLoading(true);
    await onClick(e, name);
    setLoading(false);
    setInactive(false);
  }

  const _size = size ?? "md:min-w-40 lg:max-w-60";
  const _height = height ?? "min-h-10 lg:h-10 xl:h-12";
  const textStyle = "text-sm lg:text-base";
  const _color = color ?? "blue";
  const _border = "border";

  let bgStyle;
  if (outline) {
    bgStyle = buttonOutlineColors[color] || color;
  } else {
    bgStyle = buttonColors[color] || color;
  }

  const _disabled = disabled?.value ? disabled.value : false;
  return (
    <button
      type="submit"
      onClick={(e) => handleClick(e)}
      title={title}
      className={cn(
        base,
        _size,
        _height,
        _color,
        _border,
        bgStyle,
        style,
        textStyle,
      )}
      disabled={_disabled}
    >
      {isLoading ? (
        <Spinner color="white" />
      ) : alingTextRight ? (
        <>
          {children}
          {content && (
            <p>
              <FM id={content} key={content} />
            </p>
          )}
        </>
      ) : (
        <>
          {iconLeft && <span>{iconLeft}</span>}{" "}
          {content && (
            <span className="w-auto h-full flex items-center justify-center ">
              <FM id={content} key={content} />
            </span>
          )}
          {iconRight && <span>{iconRight}</span>}
          {icon && <span>{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
}

export default Button;
